/**
 * The content hash of the main bundle this tab is executing, e.g. "a1b2c3d4"
 * from /static/js/main.a1b2c3d4.js.
 *
 * Read from the DOM at call time rather than injected at build time: what a
 * support conversation needs to know is which build the tab is RUNNING, and a
 * value compiled into the source cannot answer that when the tab is serving a
 * cached bundle. Returns null when no main bundle is present, which is the
 * normal case under the dev server and in tests.
 */
export function runningBuildHash(): string | null {
  const scripts = Array.from(document.getElementsByTagName('script'));
  for (const script of scripts) {
    const match = /\/static\/js\/main\.([0-9a-zA-Z]+)\.js/.exec(script.src || '');
    if (match) return match[1];
  }
  return null;
}
